module.exports = __webpack_public_path__ + "img/01.8e3e32fe.jpg";